import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceInstallation } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class DeviceInstallationService extends UzurvRestService {
  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Returns a list of device installations for a user
   *
   * @param driverId
   */
  getDeviceInstallationsForDriver(driverId: number): Observable<Array<DeviceInstallation>> {
    return this.get<Array<DeviceInstallation>>(`drivers/${driverId}/deviceInstallations/`).pipe(
      map(response => Deserialize(response, DeviceInstallation))
    );
  }

  /**
   * Creates a new device installation for a user
   *
   * @param driverId
   * @param deviceInstallation
   */
  createDeviceInstallationForDriver(driverId: number, deviceInstallation: DeviceInstallation): Observable<DeviceInstallation> {
    return this.post<DeviceInstallation>(`drivers/${driverId}/deviceInstallations/`, Serialize(deviceInstallation)).pipe(
      map(response => Deserialize(response, DeviceInstallation))
    );
  }

  /**
   * Updates an existing device installation
   *
   * @param driverId
   * @param deviceInstallation
   */
  updateDeviceInstallationForDriver(driverId: number, deviceInstallation: DeviceInstallation): Observable<DeviceInstallation> {
    return this.put<DeviceInstallation>(
      `drivers/${driverId}/deviceInstallations/${deviceInstallation.id}`,
      Serialize(deviceInstallation)
    ).pipe(map(response => Deserialize(response, DeviceInstallation)));
  }

  /**
   * Returns a list of device installations for a user
   *
   * @param riderId
   */
  getDeviceInstallationsForRider(riderId: number): Observable<Array<DeviceInstallation>> {
    return this.get<Array<DeviceInstallation>>(`riders/${riderId}/deviceInstallations/`).pipe(
      map(response => Deserialize(response, DeviceInstallation))
    );
  }

  /**
   * Creates a new device installation for a user
   *
   * @param riderId
   * @param deviceInstallation
   */
  createDeviceInstallationForRider(riderId: number, deviceInstallation: DeviceInstallation): Observable<DeviceInstallation> {
    return this.post<DeviceInstallation>(`riders/${riderId}/deviceInstallations/`, Serialize(deviceInstallation)).pipe(
      map(response => Deserialize(response, DeviceInstallation))
    );
  }

  /**
   * Updates an existing device installation
   *
   * @param riderId
   * @param deviceInstallation
   */
  updateDeviceInstallationForRider(riderId: number, deviceInstallation: DeviceInstallation): Observable<DeviceInstallation> {
    return this.put<DeviceInstallation>(
      `riders/${riderId}/deviceInstallations/${deviceInstallation.id}`,
      Serialize(deviceInstallation)
    ).pipe(map(response => Deserialize(response, DeviceInstallation)));
  }
}
